import { SendDeviceTokenInterface } from '@actassa/api';

export class SendDeviceToken {
    public static readonly type = '[RootState] Send device token';

    constructor(public payload: SendDeviceTokenInterface) { }
}
